import React from 'react';
import { useBooking } from '../context/BookingContext';

const DatePicker = () => {
  const { state, dispatch } = useBooking();

const handleCheckinChange = (e) => {
  const dateString = e.target.value;
  if (!dateString) return;
  
  // FIX: Create date with noon time
  const [year, month, day] = dateString.split('-').map(Number);
  const newCheckin = new Date(year, month - 1, day, 12, 0, 0, 0);
  
  let newCheckout = state.searchState.checkout;
  
  if (newCheckout && newCheckout <= newCheckin) {
    newCheckout = new Date(newCheckin);
    newCheckout.setDate(newCheckout.getDate() + 1);
    newCheckout.setHours(12, 0, 0, 0); // Also set checkout to noon
  }

  dispatch({
    type: 'UPDATE_SEARCH_STATE',
    payload: {
      checkin: newCheckin,
      checkout: newCheckout
    }
  });

  setTimeout(() => {
    dispatch({ type: 'PERFORM_SEARCH', payload: {} });
  }, 300);
};

  const handleCheckoutChange = (e) => {
    const newCheckout = new Date(e.target.value);
     if (!newCheckout) return;
    dispatch({
      type: 'UPDATE_SEARCH_STATE',
      payload: { checkout: newCheckout }
    });
    // Auto-trigger search after date change
    setTimeout(() => {
      dispatch({ type: 'PERFORM_SEARCH', payload: {} });
    }, 300);
  };

  // Format date for input[type="date"]
const formatDateForInput = (date) => {
  if (!date || !(date instanceof Date) || isNaN(date)) return '';
  
  // FIX: Normalize to noon to avoid timezone issues
  const normalized = new Date(date);
  normalized.setHours(12, 0, 0, 0);
  
  const year = normalized.getFullYear();
  const month = String(normalized.getMonth() + 1).padStart(2, '0');
  const day = String(normalized.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

  const getMinCheckoutDate = () => {
    if (!state.searchState.checkin) return '';
    const minDate = new Date(state.searchState.checkin);
    minDate.setDate(minDate.getDate() + 1);
    return formatDateForInput(minDate);
  };

  const getMinCheckinDate = () => {
    return formatDateForInput(new Date());
  };

  return (
    <>
      {/* Check-in Date */}
      <div>
        <label htmlFor="checkin-input" className="block text-xs font-semibold text-text-secondary mb-1 uppercase tracking-wider">
          Check-in
        </label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 text-gray-400">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
            </svg>
          </div>
          <input
            type="date"
            id="checkin-input"
            value={formatDateForInput(state.searchState.checkin)}
            onChange={handleCheckinChange}
            min={getMinCheckinDate()}
            className="w-full h-10 pl-10 pr-3 py-2 border border-gray-300 rounded-md text-sm bg-white cursor-pointer focus:outline-none focus:ring-1 focus:ring-brand-accent focus:border-brand-accent date-input-custom"
          />
        </div>
      </div>

      {/* Check-out Date */}
      <div>
        <label htmlFor="checkout-input" className="block text-xs font-semibold text-text-secondary mb-1 uppercase tracking-wider">
          Check-out
        </label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 text-gray-400">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
            </svg>
          </div>
          <input
            type="date"
            id="checkout-input"
            value={formatDateForInput(state.searchState.checkout)}
            onChange={handleCheckoutChange}
            min={getMinCheckoutDate()}
            className="w-full h-10 pl-10 pr-3 py-2 border border-gray-300 rounded-md text-sm bg-white cursor-pointer focus:outline-none focus:ring-1 focus:ring-brand-accent focus:border-brand-accent date-input-custom"
          />
        </div>
      </div>
    </>
  );
};

export default DatePicker;